import React from "react";
import { ProgressBar } from "devextreme-react/progress-bar";

const ProgressBarCell = ({ value, errorMessage }) => {
  const normalizeValue = (val) => {
    if (val === null || val === undefined) return 0;
    if (val === -1) return -1;
    return val * 100;
  };

  const normalizedValue = normalizeValue(value);

  if (normalizedValue === -1) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          cursor: "help",
        }}
      >
        <i
          className="dx-icon-errorcircle"
          style={{
            color: "#e63757",
            fontSize: "20px",
          }}
          title={errorMessage || "Operation failed"}
        />
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <ProgressBar
        min={0}
        max={100}
        value={normalizedValue}
        width="60%"
        stylingMode="contained"
        showStatus={false}
        className={normalizedValue === 100 ? "success-progress" : ""}
      />
    </div>
  );
};

export default ProgressBarCell;
